'use client'
import { cookies, guestSession, sessionState } from '~/store/Sessions/Sessions';
import { consultCart } from '~/store/Orders/Cart';
import { useEffect } from 'react';
import { PATHNAME } from '~/store/States/global';

function createSessionToken() {
  if (!cookies.get('Session-Id')) {
    guestSession().then((res) => {
      if (res && res.data && res.data.data) {
        // set cookie.
        cookies.set('Session-Id', res.data.data.session_id, {
          path: PATHNAME,
        });
      }
    });
  }
}

function validateSession(interval) {
  consultCart().then((res) => {
    if (!res.success) {
      clearInterval(interval);
      createSessionToken();
      sessionState.set(false);
    }
  });
}

export default function Session() {
  useEffect(() => {
    createSessionToken();
    const interval = setInterval(() => {
      validateSession(interval);
    }, 600000);

    return () => clearInterval(interval);
  }, []);
}
